import type { DateRange, DefaultTDate, RangeConfiguration } from '@branchjs/neo-components';
import { generateDateRange } from '../support/Dates/generateDateRange';

export const LAST_THREE_DAYS_DATE_RANGE: RangeConfiguration = {
  type: 'last_3_days',
  label: 'Last 3 days',
  getValue: () => generateDateRange(3),
};

export const LAST_SEVEN_DAYS_DATE_RANGE: RangeConfiguration = {
  type: 'last_7_days',
  label: 'Last 7 days',
  getValue: () => generateDateRange(7),
};

export const LAST_FOURTEEN_DAYS_DATE_RANGE: RangeConfiguration = {
  type: 'last_14_days',
  label: 'Last 14 days',
  getValue: () => generateDateRange(14),
};

export const LAST_THIRTY_DAYS_DATE_RANGE: RangeConfiguration = {
  type: 'last_30_days',
  label: 'Last 30 days',
  getValue: () => generateDateRange(30),
};

export const LAST_NINETY_DAYS_DATE_RANGE: RangeConfiguration = {
  type: 'last_90_days',
  label: 'Last 90 days',
  getValue: () => generateDateRange(90),
};

export const CUSTOM_DATE_RANGE: RangeConfiguration = {
  type: 'custom',
  label: 'Custom',
  getValue: (): DateRange<DefaultTDate> => {
    const today = new Date();
    return [today, today];
  },
};

export const ALL_TIME_DATE_RANGE: RangeConfiguration = {
  type: 'all_time',
  label: 'All time',
  getValue: (): DateRange<DefaultTDate> => {
    return [null, null];
  },
};

export const ANALYTICS_DATE_RANGES = [
  LAST_THREE_DAYS_DATE_RANGE,
  LAST_SEVEN_DAYS_DATE_RANGE,
  LAST_FOURTEEN_DAYS_DATE_RANGE,
  LAST_THIRTY_DAYS_DATE_RANGE,
  LAST_NINETY_DAYS_DATE_RANGE,
  CUSTOM_DATE_RANGE,
];

export const CREATED_DATE_RANGES = [
  LAST_THREE_DAYS_DATE_RANGE,
  LAST_SEVEN_DAYS_DATE_RANGE,
  LAST_FOURTEEN_DAYS_DATE_RANGE,
  LAST_THIRTY_DAYS_DATE_RANGE,
  LAST_NINETY_DAYS_DATE_RANGE,
  CUSTOM_DATE_RANGE,
  ALL_TIME_DATE_RANGE,
];
